/* import __COLOCATED_TEMPLATE__ from './panel-wrapper.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();